import React, { useEffect } from 'react';
import openWhatsApp from '../utils/whatsapp';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const WhatsAppCall: React.FC<Props> = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;

    const phone = process.env.REACT_APP_WHATSAPP_NUMBER; //.replace(/\D/g, '');

    const message =
      process.env.REACT_APP_MESSAGE_EMERGENCY ||
      process.env.REACT_APP_DEFAULT_MESSAGE ||
      'Hola, necesito asistencia en la vía. ¿Pueden ayudarme?';

    // Abre WhatsApp y luego cierra el "modal" en la app
    openWhatsApp(phone, message);

    // Cierra el estado en App para que el componente deje de ejecutarse hasta la próxima vez
    try {
      onClose();
    } catch (e) {
      // noop
    }
  }, [isOpen, onClose]);

  // No renderiza UI: el comportamiento es abrir WhatsApp cuando isOpen pasa a true.
  return null;
};

export default WhatsAppCall;